import {
    LEAGUES_ACTIVE_TEAMS_SUCCESS,
    LEAGUES_DASHBOARD_TEAMS_SUCCESS,
    LEAGUES_DASHBOARD_TEAMS_REQUEST,
    LEAGUES_DASHBOARD_TEAMS_FAILURE,
} from '../actions/actionTypes/leagues-action-types';

const initialState = {
    dashboardTeams: {
        tennis: [],
        pickleball: [],
    },
    isLoadingDashboardTeams: false,
    isDashboardTeamsLoaded: false,
    dashboardErrorMessage: null,
    activeTeams: {
        pickleball: [],
        tennis: [],
    },
    isActiveTeamsLoaded: false,
};

export default (state = initialState, action) => {
    switch (action.type) {
        case LEAGUES_DASHBOARD_TEAMS_REQUEST: {
            return {
                ...state,
                isLoadingDashboardTeams: true,
            };
        }
        case LEAGUES_DASHBOARD_TEAMS_SUCCESS: {
            return {
                ...state,
                dashboardTeams: action.data.teams,
                isDashboardTeamsLoaded: true,
                isLoadingDashboardTeams: false,
            };
        }
        case LEAGUES_DASHBOARD_TEAMS_FAILURE: {
            return {
                ...state,
                dashboardErrorMessage: action.error,
                isDashboardTeamsLoaded: false,
                isLoadingDashboardTeams: false,
            };
        }
        case LEAGUES_ACTIVE_TEAMS_SUCCESS: {
            return {
                ...state,
                activeTeams: action.data.memberTeams,
                isActiveTeamsLoaded: true,
            };
        }
        default:
            return state;
    }
};
